import { createActions, createReducer } from 'reduxsauce'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    removeExercicioConsultaReceitasExtraorcamentarias: [],
    removeDataRecebimentoInicialConsultaReceitasExtraorcamentarias: [],
    removeDataRecebimentoFinalConsultaReceitasExtraorcamentarias: [],
    removeAdministracaoConsultaReceitasExtraorcamentarias: ['administracao'],
    removeSituacaoConsultaReceitasExtraorcamentarias: ['situacao'],
    removeOrigemConsultaReceitasExtraorcamentarias: ['origem'],
    removeDestinacaoConsultaReceitasExtraorcamentarias: ['destinacao'],
    removeRecursoConsultaReceitasExtraorcamentarias: ['recurso'],
    removeNomeCredorConsultaReceitasExtraorcamentarias: [],
    removeCnpjConsultaReceitasExtraorcamentarias: [],
    removeCpfConsultaReceitasExtraorcamentarias: [],
    setMostraAplicarFiltroConsultaReceitasExtraorcamentarias: [],
    limpaFiltroConsultaReceitasExtraorcamentarias: [],
    aplicarFiltroConsultaReceitasExtraorcamentarias: ['filtro'],
})

const INITIAL_STATE = {
    exercicio: '',
    dataRecebimentoInicial: '',
    dataRecebimentoFinal: '',
    administracao: null,
    situacao: [],
    origem: [],
    destinacao: null,
    recurso: null,
    nomeCredor: '',
    cnpj: '',
    cpf: '',
    mostraAplicarFiltro: false,
}
const removeAdministracao = (state = INITIAL_STATE, action) => {
    state.administracao.splice(state.administracao.indexOf(action.administracao), 1)
    state.administracao = Array.from(state.administracao)
    return { ...state, mostraAplicarFiltro: true }
}
const removeExercicio = (state = INITIAL_STATE, action) => {
    return { ...state, exercicio: '', mostraAplicarFiltro: true }
}
const removeDataRecebimentoInicial = (state = INITIAL_STATE, action) => {
    return { ...state, dataRecebimentoInicial: '', mostraAplicarFiltro: true }
}
const removeDataRecebimentoFinal = (state = INITIAL_STATE, action) => {
    return { ...state, dataRecebimentoFinal: '', mostraAplicarFiltro: true }
}
const removeSituacao = (state = INITIAL_STATE, action) => {
    return { ...state, situacao: '', mostraAplicarFiltro: true }
}
const removeOrigem = (state = INITIAL_STATE, action) => {
    return { ...state, origem: '', mostraAplicarFiltro: true }
}
const removeRecurso = (state = INITIAL_STATE, action) => {
    state.recurso.splice(state.recurso.indexOf(action.recurso), 1)
    state.recurso = Array.from(state.recurso)
    return { ...state, mostraAplicarFiltro: true }
}
const removeDestinacao = (state = INITIAL_STATE, action) => {
    state.destinacao.splice(state.destinacao.indexOf(action.destinacao), 1)
    state.destinacao = Array.from(state.destinacao)
    return { ...state, mostraAplicarFiltro: true }
}
const removeNomeCredor = (state = INITIAL_STATE, action) => {
    return { ...state, nomeCredor: '', mostraAplicarFiltro: true }
}
const removeCnpj = (state = INITIAL_STATE, action) => {
    return { ...state, cnpj: '', mostraAplicarFiltro: true }
}
const removeCpf = (state = INITIAL_STATE, action) => {
    return { ...state, cpf: '', mostraAplicarFiltro: true }
}
const setMostraAplicarFiltro = (state = INITIAL_STATE, action) => {
    return { ...state, mostraAplicarFiltro: !state.mostraAplicarFiltro }
}
const aplicarFiltro = (state = INITIAL_STATE, action) => {
    action.filtro.mostraAplicarFiltro = false
    return action.filtro
}
const limpaFiltro = (state = INITIAL_STATE, action) => {
    return INITIAL_STATE
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.REMOVE_EXERCICIO_CONSULTA_RECEITAS_EXTRAORCAMENTARIAS]: removeExercicio,
    [Types.REMOVE_DATA_RECEBIMENTO_INICIAL_CONSULTA_RECEITAS_EXTRAORCAMENTARIAS]: removeDataRecebimentoInicial,
    [Types.REMOVE_DATA_RECEBIMENTO_FINAL_CONSULTA_RECEITAS_EXTRAORCAMENTARIAS]: removeDataRecebimentoFinal,
    [Types.REMOVE_ADMINISTRACAO_CONSULTA_RECEITAS_EXTRAORCAMENTARIAS]: removeAdministracao,
    [Types.REMOVE_SITUACAO_CONSULTA_RECEITAS_EXTRAORCAMENTARIAS]: removeSituacao,
    [Types.REMOVE_ORIGEM_CONSULTA_RECEITAS_EXTRAORCAMENTARIAS]: removeOrigem,
    [Types.REMOVE_RECURSO_CONSULTA_RECEITAS_EXTRAORCAMENTARIAS]: removeRecurso,
    [Types.REMOVE_DESTINACAO_CONSULTA_RECEITAS_EXTRAORCAMENTARIAS]: removeDestinacao,
    [Types.REMOVE_NOME_CREDOR_CONSULTA_RECEITAS_EXTRAORCAMENTARIAS]: removeNomeCredor,
    [Types.REMOVE_CNPJ_CONSULTA_RECEITAS_EXTRAORCAMENTARIAS]: removeCnpj,
    [Types.REMOVE_CPF_CONSULTA_RECEITAS_EXTRAORCAMENTARIAS]: removeCpf,
    [Types.SET_MOSTRA_APLICAR_FILTRO_CONSULTA_RECEITAS_EXTRAORCAMENTARIAS]: setMostraAplicarFiltro,
    [Types.LIMPA_FILTRO_CONSULTA_RECEITAS_EXTRAORCAMENTARIAS]: limpaFiltro,
    [Types.APLICAR_FILTRO_CONSULTA_RECEITAS_EXTRAORCAMENTARIAS]: aplicarFiltro,
})
